import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { HeadingType } from '@freelancer/ui/heading';
import { InputSize, InputType } from '@freelancer/ui/input';
import { Margin } from '@freelancer/ui/margin';
import { TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-contest-duration',
  template: `
    <fl-heading
      i18n="Post Job Page form contest duration field label"
      [headingType]="HeadingType.H3"
      [flMarginBottom]="Margin.XXXSMALL"
      [size]="TextSize.MID"
    >
      How long would you like to run your contest?
    </fl-heading>
    <fl-grid>
      <fl-col [col]="12" [colTablet]="6">
        <fl-input
          flTrackingLabel="DurationInputField"
          beforeLabel="Days"
          i18n-beforeLabel="
             Post Job Page form contest duration input label representing units
          "
          [control]="control"
          [flMarginBottom]="Margin.LARGE"
          [flTrackingExtraParams]="{ value: control.value }"
          [size]="InputSize.LARGE"
          [type]="InputType.NUMBER"
        ></fl-input>
      </fl-col>
    </fl-grid>
  `,
})
export class ContestDurationComponent {
  TextSize = TextSize;
  HeadingType = HeadingType;
  InputSize = InputSize;
  InputType = InputType;
  Margin = Margin;

  @Input() control: FormControl;
}
